import {InvoicePrintModel} from './_models'

/**
 * The organisation's page of a registered invoice (backend taxPublicUrl, from the organisation's
 * api/v2/invoice/print-link): printed as a second QR code beside the panel's own. Only an https
 * address of tax.gov.ir is printed, so an unexpected value never becomes a code that leads elsewhere.
 */
export const TAX_PUBLIC_QR_CAPTION = 'سامانه مؤدیان'

export const taxPublicQrValue = (
  invoice: Pick<InvoicePrintModel, 'taxPublicUrl'>
): string | null => {
  const value = (invoice.taxPublicUrl || '').trim()
  if (!value) return null
  try {
    const url = new URL(value)
    const host = url.hostname.toLowerCase()
    return url.protocol === 'https:' && (host === 'tax.gov.ir' || host.endsWith('.tax.gov.ir'))
      ? value
      : null
  } catch {
    return null
  }
}
